var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-color-filter" }, [
    _c(
      "div",
      { staticClass: "filter-conditions" },
      _vm._l(_vm.clone, function (condition, index) {
        return _c(
          "div",
          { key: "condition-" + index, staticClass: "filter-row" },
          [
            _c(
              "a-select",
              {
                staticStyle: { width: "250px", "margin-right": "8px" },
                model: {
                  value: _vm.clone[index].color,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone[index], "color", $$v)
                  },
                  expression: "clone[index].color",
                },
              },
              _vm._l(_vm.colors, function (color) {
                return _c(
                  "a-select-option",
                  { key: color.name, attrs: { value: color.code } },
                  [
                    _c("div", { staticClass: "color-option" }, [
                      _c("div", {
                        staticClass: "color-box",
                        style: { backgroundColor: color.code },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(color.name))]),
                    ]),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c("CustomPicker", {
              staticStyle: { width: "30%", "margin-right": "8px" },
              attrs: {
                items: _vm.fields,
                idKey: "_id",
                labelKey: "name",
                title: _vm.$t("message.field"),
              },
              on: {
                input: function ($event) {
                  return _vm.onFieldChange(condition, index)
                },
              },
              model: {
                value: _vm.clone[index].fieldId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone[index], "fieldId", $$v)
                },
                expression: "clone[index].fieldId",
              },
            }),
            _vm._v(" "),
            _c("CustomPicker", {
              staticStyle: { width: "25%", "margin-right": "8px" },
              attrs: {
                items: _vm.getOperators(condition),
                idKey: "value",
                labelKey: "label",
                title: _vm.$t("tables.operator"),
                disabled: !condition.fieldId,
              },
              on: {
                input: function ($event) {
                  return _vm.onOperatorChange(condition, index)
                },
              },
              model: {
                value: _vm.clone[index].operator,
                callback: function ($$v) {
                  _vm.$set(_vm.clone[index], "operator", $$v)
                },
                expression: "clone[index].operator",
              },
            }),
            _vm._v(" "),
            _c(_vm.getValueInputComponent(condition), {
              tag: "component",
              staticStyle: { width: "30%", "margin-right": "8px" },
              attrs: {
                options: _vm.getFieldOptions(condition),
                placeholder: _vm.$t("message.value"),
                disabled: !condition.operator,
              },
              model: {
                value: _vm.clone[index].value,
                callback: function ($$v) {
                  _vm.$set(_vm.clone[index], "value", $$v)
                },
                expression: "clone[index].value",
              },
            }),
            _vm._v(" "),
            _c("a-button", {
              attrs: { type: "danger", icon: "delete" },
              on: {
                click: function ($event) {
                  return _vm.removeCondition(index)
                },
              },
            }),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "filter-actions" },
      [
        _c(
          "a-button",
          {
            attrs: { type: "dashed", icon: "plus" },
            on: { click: _vm.addCondition },
          },
          [_vm._v(_vm._s(_vm.$t("tables.addCondition")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }